/**
 * routesString.tsx
 * [Readme] --------------------------------------------------------------------------------------
 *
 * 각 페이지가 표출되는 라우터를 지정한 파일입니다.
 * 
 * -----------------------------------------------------------------------------------------------
 */

export const RoutesString = {
  // 메인 페이지
  Main: '/',

  // GNB(브랜드) > 브랜드 스토리 (핵심가치)
  Brand: '/brand',  

  // GNB(브랜드) > 브랜드 스토리 > 히스토리
  History: '/brand/history',

  // GNB(브랜드) > 브랜드 스토리 > BI
  Bi: '/brand/bi',

  // GNB(브랜드) > 기술(Expert Solution)
  Skill: '/brand/skill',

  // GNB(브랜드) > 기술(Expert Solution) : 기술 상세보기
  SkillDetail: '/brand/skill/:skillId',
  
  // GNB(브랜드) > 상품
  Product: '/brand/product',

  // GNB(브랜드) > 브랜드 뉴스
  BrandNews: '/brand/news',

  // GNB(분양) > 연간분양일정
  Schedule: '/sales/Schedule',

  // GNB(분양) > 마이홈 (종합정보)
  MyPage: '/myHome',

  // GNB(분양) > 마이홈 > 분양대금납부조회 : 납부내역요약
  Payment: '/myHome/payment',
  
  // GNB(분양) > 마이홈 > 분양대금납부조회 : 아파트
  PaymentApart: '/myHome/payment/apart',
  
  // GNB(분양) > 마이홈 > 분양대금납부조회 : 별매품 1
  Separately: '/myHome/payment/separately',
  
  // GNB(분양) > 마이홈 > 분양대금납부조회 : 별매품 2
  Separately2: '/myHome/payment/separately2',

    // GNB(분양) > 마이홈 > 분양대금납부조회 : 별매품 3
  Separately3: '/myHome/payment/separately3',
  
  // GNB(분양) > 마이홈 > 입주자 사전방문행사 예약
  FamilRV: '/myHome/family',

  // GNB(분양) > 마이홈 > 입주자 사전방문행사 예약 : 예약 시간 선택
  FamilyRVTime: '/myHome/family/time',

  // GNB(분양) > 마이홈 > 입주자 사전방문행사 예약 : 예약 결과 확인
  BookingEventInfo: '/myHome/family/bookingEvent',

  // GNB(분양) > 마이홈 > 입주 예약 
  MoveIn: '/myHome/moveIn',

  // GNB(분양) > 마이홈 > 입주 예약 : 예약 시간 선택
  MoveInTime: '/myHome/moveIn/time',

  // GNB(분양) > 마이홈 > 입주 예약 : 예약 결과 확인
  BookingInfor: '/myHome/moveIn/booking',

  // GNB(분양) > 마이홈 > A/S 신청 : 하자 신청 페이지
  AsSection01: '/myHome/asSection01',

  // GNB(분양) > 마이홈 > A/S 신청 : 문의 신청 페이지
  AsSection02: '/myHome/asSection02',

  // GNB(분양) > 마이홈 > A/S 신청 : 문의 신청 페이지 > 문의 등록
  AsApply: '/myHome/asApply',

  // GNB(분양) > 마이홈 > A/S 신청 : 문의 신청 페이지 > 문의 수정
  AsEditSection: '/myHome/asEdit',

  // GNB(분양) > 마이홈 > 리빙가이드(eLife 가이드)
  LivingGuide: '/myHome/livingGuide',

  // GNB(분양) > 마이홈 > 환기필터케어
  Ventilation: '/myHome/ventilation',

  // GNB(분양) > 마이홈 > 단지 소식
  Complex: '/myHome/complex',

  // GNB(분양) > 마이홈 > 단지 소식 : 특정 단지 소식 상세 보기
  ComplexInfo: '/myHome/complex/:id',

  // 로그인
  Login: '/auth/login',
  
  // 비회원 문의/인증을 위한 로그인 화면(23.03.15)
  LoginNonMbrBtn: '/auth/loginNonMbrBtn',

  // 로그인 > 아이디 찾기
  FindId: '/auth/findId',

  // 로그인 > 전체 아이디 찾기
  FindAllId: '/auth/findAllId',

  // 로그인 > 비밀번호 찾기
  FindPw: '/auth/findPw',

  // 로그인 > 비밀번호 찾기 > 비밀번호 초기화
  InitPassword: '/auth/initPw',

  // 로그인 > 회원가입
  JoinMember: '/auth/joinMember',

  // 로그인 > 로그인(성공) > 다중 로그인 확인
  OverLap: '/auth/joinMember/overLap',

  // 로그인 > 로그인(성공) > 휴면 해제
  DormantAccount: '/auth/dormant',

  // 로그인 > 로그인(성공) > 개인정보 재동의
  Reapply: '/reapply',
  
  // 로그인 > 로그인(성공) > 비밀번호 재설정(6개월)
  ChangePWRefeat: '/auth/changePWRefeat',

  // 개인정보 변경 > 비밀번호 확인
  ConfirmPassword: '/auth/confirmPw',

  // 개인정보 변경 > 정보변경
  ChangeInfo: '/auth/change',

  // 개인정보 변경 > 회원탈퇴
  Secession: '/auth/secession',

  // 비밀번호 변경
  ChangePW: '/auth/changePW',
  
  // 계약자 정보 확인
  LocationVerify: '/locationVerify',
  
  // 계약자 정보 변경
  ContractInfoChange: '/myHome/contract/change',

  // 관심단지
  IntersetComplex: '/auth/interset',

  // Footer > 공지사항
  FooterNotice: '/footer/footerNotice01',

  // Footer > 공지사항 : 상세보기
  FooterNotice2: '/footer/footerNotice02',

  // Footer > 이벤트
  FooterEvent01: '/footer/footerEvent01',

  // Footer > 이벤트 : 상세보기
  FooterEvent02: '/footer/footerEvent02',

  // Footer > 고객문의 > 자주 묻는 질문
  FooterQuestion: '/footer/question',

  // Footer > 고객문의 > 문의 내역
  FooterQuestion2: '/footer/question2',

  // Footer > 고객문의 > 문의 내역 > 등록
  FooterQuestion3: '/footer/question3',

  // Footer > 고객문의 > 문의 내역 > 상세 보기
  FooterQuestion4: '/footer/question4',

  // Footer > 고객문의 > 문의 내역 > 상세 보기 > 수정
  FooterQuestion5: '/footer/question5',

  // Footer > 이메일 무단 수집 거부
  Email: '/email',

  // Footer > 이용약관
  Agree: '/agree',

  // Footer > 개인정보처리방침
  Person: '/person',

  // Footer > 영상정보처리기기 운영 및 관리방침
  Policy: '/footer/policy',

  // Footer > 사이트맵
  Sitemap: '/footer/footerSitemap',

  // Footer > 건축환경연구센터
  Laboratory: '/footer/laboratory',

  // e편한세상 찾기
  FooterFoundList: '/footer/footerFound_list',

  // e편한세상 찾기 : 공사정보 더보기
  FooterConstructionInfo: '/footer/constructionInfo',

  // (개발서버 한정) 프로토타입 컴포넌트
  Prototype: '/prototype',

  // 위 라우터에 모두 포함되지 않는 찾을 수 없는 페이지
  NoPage: '/noPage'
};
